"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _clientAuth = require("@devsta/client-auth");

var _query = _interopRequireWildcard(require("@devsta/query"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _commonReact = require("@devsta/common-react");

var _reactApollo = require("react-apollo");

var _OrganisationInvite = _interopRequireDefault(require("../components/OrganisationInvite"));

var _OrganisationInviteError = _interopRequireDefault(require("../components/OrganisationInviteError"));

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

var _getOrganisationInvite = _interopRequireDefault(require("../queries/getOrganisationInvite"));

var _addImageToOrganisation = _interopRequireDefault(require("../utils/addImageToOrganisation"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function OrganisationInvite(_ref) {
  var history = _ref.history;
  var tempAuthToken = new URLSearchParams(history.location.search).get('t');

  var _credentials$get = _clientAuth.credentials.get(),
      localToken = _credentials$get.token;

  if (!tempAuthToken && !localToken) {
    return _react.default.createElement(_commonReact.NotFound, null);
  }

  return _react.default.createElement(_reactApollo.ApolloConsumer, null, function (apolloClient) {
    return _react.default.createElement(_query.default, {
      query: _getOrganisationInvite.default,
      context: {
        module: 'organisations'
      },
      tempAuthToken: tempAuthToken || localToken,
      shouldDisplayError: false
    }, function (response) {
      var _response$data = response.data,
          data = _response$data === void 0 ? {} : _response$data,
          error = response.error;
      return _react.default.createElement(_query.QueryAfterware, {
        data: {
          data: data,
          error: error
        },
        action: (0, _addImageToOrganisation.default)(apolloClient, tempAuthToken)
      }, function (_ref2) {
        var modifiedData = _ref2.data;
        var organisationWithImage = modifiedData.organisationWithImage,
            userEmail = modifiedData.userEmail;

        if (error) {
          return _react.default.createElement(_OrganisationInviteError.default, {
            error: error,
            organisation: organisationWithImage,
            userEmail: userEmail,
            history: history,
            apolloClient: apolloClient
          });
        }

        return _react.default.createElement(_OrganisationInvite.default, {
          history: history,
          user: (0, _lodash.default)(data, 'getOrganisationInvite.user', {}),
          teamId: (0, _lodash.default)(data, 'getOrganisationInvite.teamId'),
          organisation: organisationWithImage,
          authToken: tempAuthToken,
          apolloClient: apolloClient,
          tempToken: tempAuthToken || localToken
        });
      });
    });
  });
}

var _default = (0, _withBasedRouter.default)(_basePath.default, OrganisationInvite);

exports.default = _default;